import { useQuery } from "@tanstack/react-query";

import { getBeefFeedAdditive, getBeefFeedAdditiveAdmin } from "services";

import { getEnvironment } from "utils";

import { DEFAULT_CACHE, FOOTPRINTING_BEEF_FEED_ADDITIVE } from "consts";

import { UploadableBeefFeedAdditive } from "models";

export const useGetFootprintingBeefFeedAdditive = (primaryDataId: string, options?: { enabled?: boolean }) => {
  const isAdmin = getEnvironment().admin;

  return useQuery<UploadableBeefFeedAdditive[]>({
    queryKey: [FOOTPRINTING_BEEF_FEED_ADDITIVE, primaryDataId, isAdmin],
    queryFn: () => (isAdmin ? getBeefFeedAdditiveAdmin(primaryDataId) : getBeefFeedAdditive(primaryDataId)),
    enabled: options?.enabled !== false && !!primaryDataId,
    gcTime: DEFAULT_CACHE.gcTime,
    staleTime: DEFAULT_CACHE.staleTime,
  });
};
